import React, { useState } from "react";

const categories = [
  { id: "electronics", name: "Electronics" },
  { id: "clothing", name: "Clothing" },
  { id: "furniture", name: "Furniture" },
];

const attributes = {
  electronics: [{ id: "a1", name: "Brand" }, { id: "a2", name: "Warranty" }],
  clothing: [{ id: "a3", name: "Material" }, { id: "a4", name: "Size" }],
  furniture: [{ id: "a5", name: "Wood Type" }, { id: "a6", name: "Color" }],
};

export default function MultiSelectForm() {
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [values, setValues] = useState<{ [key: string]: string[] }>({});

  const toggleCategory = (cat: string) => {
    setSelectedCategories((prev) =>
      prev.includes(cat) ? prev.filter((c) => c !== cat) : [...prev, cat]
    );
  };

  const handleValueChange = (attrId: string, index: number, value: string) => {
    setValues((prev) => ({
      ...prev,
      [attrId]: prev[attrId] ? prev[attrId].map((v, i) => (i === index ? value : v)) : ["", ""],
    }));
  };

  return (
    <div className="p-4">
      {/* Category Selection */}
      <h2 className="text-lg font-semibold mb-2">Select Categories:</h2>
      <div className="flex gap-2 mb-4">
        {categories.map((cat) => (
          <button
            key={cat.id}
            className={`px-4 py-2 border rounded ${
              selectedCategories.includes(cat.id) ? "bg-blue-500 text-white" : "bg-gray-200"
            }`}
            onClick={() => toggleCategory(cat.id)}
          >
            {cat.name}
          </button>
        ))}
      </div>

      {/* Attributes Table */}
      <table className="w-full border">
        <thead>
          <tr className="bg-gray-200">
            <th className="p-2 border">Category</th>
            <th className="p-2 border">Attribute</th>
            <th className="p-2 border">Value 1</th>
            <th className="p-2 border">Value 2</th>
          </tr>
        </thead>
        <tbody>
          {selectedCategories.flatMap((cat) =>
            attributes[cat]?.map((attr) => (
              <tr key={attr.id}>
                <td className="p-2 border">{cat}</td>
                <td className="p-2 border">{attr.name}</td>
                <td className="p-2 border">
                  <input
                    type="text"
                    className="w-full p-1 border rounded"
                    value={values[attr.id]?.[0] || ""}
                    onChange={(e) => handleValueChange(attr.id, 0, e.target.value)}
                  />
                </td>
                <td className="p-2 border">
                  <input
                    type="text"
                    className="w-full p-1 border rounded"
                    value={values[attr.id]?.[1] || ""}
                    onChange={(e) => handleValueChange(attr.id, 1, e.target.value)}
                  />
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
